import React, { useEffect, useState } from 'react';
import { Button, DateInput } from '../../components/common';
import { openPeriodService } from '../../services/resources';
import { apiError } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

// Matches the server-side floor in openPeriod.controller.js — system start date.
const EARLIEST_OPEN_DATE = '2026-07-01';

export default function OpenPeriodTab({ onToast }) {
  const { can } = useAuth();
  const canEdit = can('SETTINGS', 'CanEdit');
  const [form, setForm] = useState({ open_date_from: '', open_date_to: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    openPeriodService
      .get()
      .then((d) =>
        setForm({
          open_date_from: d.open_date_from ? String(d.open_date_from).slice(0, 10) : '',
          open_date_to: d.open_date_to ? String(d.open_date_to).slice(0, 10) : '',
        })
      )
      .catch((err) => onToast?.(apiError(err).message, 'error'))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    if (form.open_date_from < EARLIEST_OPEN_DATE) {
      onToast?.(`Open Date From cannot be earlier than ${EARLIEST_OPEN_DATE} (system start date).`, 'error');
      return;
    }
    setSaving(true);
    try {
      await openPeriodService.save(form);
      onToast?.('Open period saved');
    } catch (err) {
      onToast?.(apiError(err).message, 'error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="text-sm text-gray-400">Loading…</p>;

  return (
    <form onSubmit={save} className="max-w-lg space-y-4">
      <p className="text-sm text-gray-500">
        Transactions can only be dated within this range. Dates outside it are rejected.
      </p>
      <div className="grid grid-cols-2 gap-3">
        <DateInput
          label="Open Date From"
          value={form.open_date_from}
          disabled={!canEdit}
          onChange={(v) => set('open_date_from', v)}
          error={form.open_date_from && form.open_date_from < EARLIEST_OPEN_DATE ? `Cannot be earlier than ${EARLIEST_OPEN_DATE}` : undefined}
        />
        <DateInput
          label="Open Date To"
          value={form.open_date_to}
          disabled={!canEdit}
          onChange={(v) => set('open_date_to', v)}
        />
      </div>
      {canEdit && (
        <Button type="submit" disabled={saving}>
          {saving ? 'Saving…' : 'Save changes'}
        </Button>
      )}
    </form>
  );
}
